<template>
  <div class="flex flex-col">
    <!-- Header -->
    <header class="py-4">
      <div class="container mx-auto flex justify-between items-center">
        <h1 class="text-2xl font-bold">Peachy Pro Studios</h1>
        <nav>
          <a href="#"
            class="mx-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition duration-300">Signup</a>
          <a href="#"
            class="mx-2 px-4 py-2 border border-orange-500 text-orange-500 rounded-lg hover:bg-orange-500 hover:text-white transition duration-300">Login</a>
          <a href="#" class="mx-2 hover:underline">Pricing</a>
          <a href="#" class="mx-2 hover:underline">Testimonials</a>
          <a href="#" class="mx-2 hover:underline">Contact</a>
        </nav>
      </div>
    </header>

    <!-- Main Content -->
    <main class="flex-grow">
      <slot />
    </main>

    <!-- Footer -->
    <footer class="bg-orange-600 text-white py-6">
      <div class="container mx-auto text-center">
        <p class="text-sm">&copy; 2023 Peachy Pro Studios. All rights reserved.</p>
        <div class="flex justify-center space-x-4 mt-4">
          <a href="#" class="hover:text-gray-200 transition">Privacy Policy</a>
          <a href="#" class="hover:text-gray-200 transition">Terms of Service</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts" setup>
// ...existing code...
</script>

<style scoped>
/* Tailwind CSS is used for styling, no additional scoped styles needed */

/* Ensure the layout takes up the full height of the screen */
html,
body {
  height: 100%;
  margin: 0;
}

.flex-grow {
  flex-grow: 1;
}
</style>